import NoticeModularService from '../notice-modular-service';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import { purchaseProjectStatus } from '@/utils/mixins/purchase-project-status';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination
  },
  mixins: [purchaseProjectStatus],
  data () {
    return {
      tabList: [], // tab集合
      tabList2: [
        {
          name: '交易项目',
          value: '0',
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableList: []
        }
        // {
        //   name: '集中交易项目',
        //   value: '1',
        //   total: 0,
        //   pageNum: 1,
        //   pageSize: 10,
        //   tableList: []
        // }
      ],
      activeName: '0',
      tabActiveType: 1,
      total: 0,
      tableList: [],
      searchForm: {
        projectType: 1, // 1转让 2采购
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  created () {
    // 获取tab按钮字典
    const arr = [
      ['PROJECT_CATEGORY']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value).then(res => {
        if (res && res.code === '0') {
          this.tabList = res.data;
        }
      });
      Service.getSelectList('BACTH_PROJECT_TYPE').then(res => {
        if (res && res.code === '0') {
          this.projectStatusArr = res.data;
        }
      });
    });
    this.getSignUpRecordList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    changeTabIndex (type) {
      this.tabActiveType = type;
      this.searchForm.projectType = type;
      this.activeName = 0;
      this.getSignUpRecordList();
      // console.log(this.tabActiveType);

    },
    handleClick () {
      // console.log(this.activeName);
      if (this.activeName === '1') {
        this.batchTradingVerificationList();

      } else {
        this.getSignUpRecordList();
      }
    },
    batchTradingVerificationList (page) {
      this.tableList = [];
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      }
      NoticeModularService.batchTradingVerificationList(this.searchForm).then(res => {
        if (res && res.code === '0') {
          this.tableList = res.data.list;
          this.total = res.data.total;
          this.tableList.forEach(item => {
            // 公示日期转化
            item.transactionAnnouncementTime = this.$options.filters['baseDate'](item.transactionAnnouncementTime);
          });
        }
      });
    },
    // 获取交易公示列表
    getSignUpRecordList (page) {
      this.tableList = [];
      if (page) {
        this.searchForm.projectType = this.searchForm.projectType;
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      }
      NoticeModularService.tradingVerificationList(this.searchForm).then(res => {
        if (res && res.code === '0') {
          this.tableList = res.data.list;
          this.total = res.data.total;
          this.tableList.forEach(item => {
            // 公示日期转化
            item.transactionAnnouncementTime = this.$options.filters['baseDate'](item.transactionAnnouncementTime);
          });
        }
      });
    },
    clear () {
      this.searchForm = {
        projectType: '',
        pageNum: 1,
        pageSize: 5
      };
      this.getSignUpRecordList();
    },
    handdle (row, event, column) {
      console.log(row, event, column);
      if (this.activeName === '1') {
        this.$router.push('/notice-modular/witnessbatchDeatil?projectId=' + row.id+ '&projectType=' + row.projectType +'&userId=' + row.userId + '&createTime=' +row.createTime);
      }else {
        this.$router.push('/notice-modular/noticeDeatil?id=' + row.projectId + '&time=' + row.transactionAnnouncementTime + '&type=' + this.tabActiveType + '&userId=' + row.userId);
      }

    }
  }
};
